/* eslint-disable jsx-a11y/alt-text */
import React, { PureComponent, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import OriginalGoodsItem from "../../components/store/OriginalGoodsItem";

class StoreIntro extends PureComponent {
  _goStore = (store) => {
    //window.open('http://ara1215.ivyro.net/_aniplus/220109/pages/store_info.html', '', '')
    window.scrollTo(0, 0);
    const { history } = this.props;
    history.push('/storeInfo/' + store);
  };
  render() {
    const { imgUrl } = this.props;
    return (
      <Fragment>
        <div className="store_intro" id="store_intro">
          <div className="store_intro_tit">
            <h3>
              애니메이션 굿즈샵의 신세계<em>!</em>
            </h3>
            <p className="dsc">A Whole New World of Anime Goods Store!</p>
            <div className="summary">
              한.일 동시방영 애니메이션 채널 애니플러스는
              <br />
              국내 최초로 전국 4개 도시에서 일본 애니메이션 오프라인 상품
              판매망을 구축하여
              <br />
              콜라보 카페 , 오리지널 굿즈, 제일복권, 가챠 등 다양한 이벤트와
              함께 최신 일본 애니메이션 상품을 판매하고 있습니다.
            </div>
          </div>
          <ul className="store_intro_list">
            <li
              className="store_intro_item"
              onClick={() => this._goStore('hapjung')}
            >
              <div className="store_brench su_hj">
                <div className="brench_top">
                  <p className="name">서울 합정점</p>
                  <p className="summary">최대 규모 최대 굿즈!</p>
                </div>
                <div className="brench_img">
                  <img src={imgUrl + '/img/store/sample_img07.png'} />
                </div>
              </div>
            </li>

            {/* <li
              className="store_intro_item"
              onClick={() => this._goStore('daejeon')}
            >
              <div className="store_brench dj_ja">
                <div className="brench_top">
                  <p className="name">대전 중앙로점</p>
                  <p className="summary">계단식 공간의 미학</p>
                </div>
                <div className="brench_img">
                  <img src={imgUrl + '/img/store/sample_img08.png'} />
                </div>
              </div>
            </li>

            <li
              className="store_intro_item"
              onClick={() => this._goStore('gwangju')}
            >
              <div className="store_brench gj_cj">
                <div className="brench_top">
                  <p className="name">광주 충장로점</p>
                  <p className="summary">카페안에 영화관이 있다?</p>
                </div>
                <div className="brench_img">
                  <img src={imgUrl + '/img/store/sample_img09.png'} />
                </div>
              </div>
            </li> */}

            <li
              className="store_intro_item"
              onClick={() => this._goStore('busan')}
            >
              <div className="store_brench bs_sm">
                <div className="brench_top">
                  <p className="name">부산 서면점</p>
                  <p className="summary">인터렉티브 존의 또다른 즐거움</p>
                </div>
                <div className="brench_img">
                  <img src={imgUrl + '/img/store/sample_img10.png'} />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(StoreIntro)));
